import {buildAsyncActionsCreator, createAsyncActionExecutor} from '../asyncUtils';
import {ModelAccessActions} from './types';
import {requestList, setList} from './api';

const modelAccessLoadListActionsCreator = buildAsyncActionsCreator(ModelAccessActions.REQUEST_LIST);
export const modelAccessLoadList = createAsyncActionExecutor(modelAccessLoadListActionsCreator, requestList);

const modelAccessUpdateListActionsCreator = buildAsyncActionsCreator(ModelAccessActions.UPDATE);
export const modelAccessUpdateList = createAsyncActionExecutor(modelAccessUpdateListActionsCreator, setList);
